/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Avatar from 'react-avatar';
import { textEllipsis } from '../../../shared/utils/constants';

export default function columns(t) {
  return [
    {
      title: t('mnt_communication_channel.fileUrl'),
      field: 'fileUrl',
      render: (rowData) => (
        <Avatar
          size="40"
          round="20px"
          src={rowData.fileUrl}
          name={rowData.name}
        />
      ),
    },
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.name'),
      field: 'name',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { name } = rowData;
        return (
          <span className="tooltip-test" title={name}>
            {name}
          </span>
        );
      },
    },
    {
      title: t('general.description'),
      field: 'description',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { description } = rowData;
        return (
          <span className="tooltip-test" title={description}>
            {description}
          </span>
        );
      },
    },
    {
      title: t('mnt_communication_channel.availableTo'),
      field: 'availableToDescription',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { availableToDescription } = rowData;
        return (
          <span className="tooltip-test" title={availableToDescription}>
            {availableToDescription}
          </span>
        );
      },
    },
    {
      title: t('mnt_communication_channel.unreadMessageQuantity'),
      field: 'unreadMessageQuantity',
    },
  ];
}
